import { Label } from "../../ui/label";
import { Input } from "../../ui/input";
import { Switch } from "../../ui/switch";
import AdvancedSection from "./AdvancedSection";

export default function TramoEdadConfig({ config, onChange }) {
  const actividad = config?.factores?.actividad || {};
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
        <div>
          <p className="text-sm font-medium text-gray-800">Factor por actividad (riesgo)</p>
          <p className="text-xs text-gray-500">Multiplica la prima según el factor de riesgo de la actividad del asegurado.</p>
        </div>
        <Switch checked={!!actividad.activo} onCheckedChange={(v) => onChange("factores.actividad.activo", v)} />
      </div>

      <AdvancedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs text-gray-500">Precio base — Tabla</Label>
            <Input value={config?.precioBase?.tabla || ""} onChange={(e) => onChange("precioBase.tabla", e.target.value)} placeholder="precios_base" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Precio base — Campo Resultado</Label>
            <Input value={config?.precioBase?.campoResultado || ""} onChange={(e) => onChange("precioBase.campoResultado", e.target.value)} placeholder="precio_uf" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Factor actividad — Tabla</Label>
            <Input value={actividad.tabla || ""} onChange={(e) => onChange("factores.actividad.tabla", e.target.value)} placeholder="actividades" />
          </div>
          <div>
            <Label className="text-xs text-gray-500">Factor actividad — Campo</Label>
            <Input value={actividad.campo || ""} onChange={(e) => onChange("factores.actividad.campo", e.target.value)} placeholder="factor_riesgo" />
          </div>
        </div>
      </AdvancedSection>
    </div>
  );
}
